var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6868 4.63519C13.1726 3.15019 11.7618 2.08353 10.1018 2.08353C8.00762 2.07519 6.30262 3.76519 6.29346 5.85936V5.87603V7.66519",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2775 17.5005H6.91C5.165 17.5005 3.75 16.0855 3.75 14.3396V10.7663C3.75 9.02047 5.165 7.60547 6.91 7.60547H13.2775C15.0225 7.60547 16.4375 9.02047 16.4375 10.7663V14.3396C16.4375 16.0855 15.0225 17.5005 13.2775 17.5005Z",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0939 11.627V13.4786",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/Unlock.041c3cfd57c7a4e9837d0e9b6443080c.svg";
export { ForwardRef as ReactComponent };